"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _chevronRightSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right-small"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const AccordionItemHeader = (0, _react.forwardRef)((props, ref) => {
  const {
    prefix,
    ssrIcon,
    iconState,
    small,
    title,
    subtitle,
    onClick,
    disabled,
    className,
    onFocus,
    onBlur,
    ...other
  } = props;
  const accordionHeaderClasses = (0, _classnames.default)(className, `${prefix}accordion-item-header`, small && `${prefix}accordion-item-header--small`);
  return _react.default.createElement("button", _extends({
    type: "button",
    disabled: disabled,
    className: accordionHeaderClasses,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    ref: ref
  }, other), _react.default.createElement("span", {
    className: `${prefix}accordion-item-header__title-wrapper`
  }, _react.default.createElement("span", {
    className: `${prefix}accordion-item-header__title`
  }, title), subtitle && _react.default.createElement("span", {
    className: `${prefix}accordion-item-header__subtitle`
  }, subtitle)), _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    className: `${prefix}accordion-item-header__icon`,
    paths: ssrIcon,
    modifier: iconState
  }));
});
AccordionItemHeader.defaultProps = {
  title: '',
  subtitle: '',
  prefix: '',
  ssrIcon: _chevronRightSmall.default
};
var _default = AccordionItemHeader;
exports.default = _default;